import { supabase } from "../supabase";
import type { ProgressRecord } from "../types";

interface ProgressRow {
  profile_id: string;
  program_id: string | null;
  completed: number;
  total: number;
  upcoming: string | null;
  upcoming_date: string | null;
  blockers: { kind: string; text: string; severity: string }[];
  recommendation: string | null;
  recent_grades: { lesson: string; grade: string; date: string }[];
  dual_hours: number;
  solo_hours: number;
  total_hours: number;
  programs?: { name: string }[] | { name: string } | null;
  profiles?: unknown;
}

function programName(p: ProgressRow["programs"]): string {
  if (!p) return "";
  if (Array.isArray(p)) return p[0]?.name ?? "";
  return p.name ?? "";
}

export async function mapBySchool(schoolId: string): Promise<Record<string, ProgressRecord>> {
  const { data, error } = await supabase
    .from("progress_records")
    .select(
      "profile_id, program_id, completed, total, upcoming, upcoming_date, blockers, recommendation, recent_grades, dual_hours, solo_hours, total_hours, programs(name), profiles!inner(school_id)",
    )
    .eq("profiles.school_id", schoolId);
  if (error) throw error;
  const out: Record<string, ProgressRecord> = {};
  for (const r of (data ?? []) as unknown as ProgressRow[]) {
    out[r.profile_id] = {
      program: programName(r.programs),
      completed: r.completed,
      total: r.total,
      upcoming: r.upcoming ?? "",
      upcomingDate: r.upcoming_date ?? "",
      blockers: r.blockers ?? [],
      recommendation: r.recommendation ?? "",
      recentGrades: r.recent_grades ?? [],
      flightHours: {
        dual: Number(r.dual_hours),
        solo: Number(r.solo_hours),
        total: Number(r.total_hours),
      },
    };
  }
  return out;
}
